
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.32 9.86V8.18h-2.5v-2.5H7.18v2.5h-2.5v1.68h2.5v2.5h1.64v-2.5h2.5zm2.422 3.163l1.758 1.758v.899H.5v-.899l1.758-1.758V8.18c0-1.25.43-2.422 1.289-3.516.86-1.094 1.9-1.784 3.125-2.07v-.586c0-.365.13-.677.39-.938.26-.26.573-.39.938-.39s.677.13.938.39c.26.26.39.573.39.938v.586c1.276.286 2.33.963 3.164 2.031a5.536 5.536 0 011.25 3.555v4.843zM6.36 16.5h3.282c0 .443-.17.833-.508 1.172-.313.338-.69.508-1.133.508-.443 0-.833-.17-1.172-.508A1.676 1.676 0 016.36 16.5z","fill":"currentColor"}})])
          )
        }
      }
    